import {
  getStartAndEndTimes,
  getTimeSlotTime,
} from '@pages/SchedulePage/utils';
import { Provider, ProviderAvailability } from '@types';
import { TimeOfDay } from '../Filters/filtersTypes';

interface FilterAvailabilitiesProps {
  availabilities: ProviderAvailability[];
  timeOfDay: TimeOfDay | null;
  hour: number | null;
  date: string;
}
interface SoonestProviderIdProps {
  provider: Provider;
  times: string[];
  date: string;
}
export const MIN_VISIBLE_TIMES = 3;
export const MAX_VISIBLE_TIMES = 12;

export function getVisibleTimes(times: string[], isExpanded: boolean) {
  if (isExpanded) {
    return times.slice(0, MAX_VISIBLE_TIMES);
  }

  return times.slice(0, MIN_VISIBLE_TIMES);
}

export function filterAvailabilities({
  availabilities,
  timeOfDay,
  hour,
  date,
}: FilterAvailabilitiesProps) {
  return availabilities.reduce<
    Array<{
      provider: Provider;
      times: string[];
      lastEndedVisitDateTime: string;
      date: string;
    }>
  >((filtered, availability) => {
    const {
      timeSlotCollection,
      provider,
      lastEndedVisitDateTime = '',
    } = availability;
    const { times } = timeSlotCollection[0];
    if (!timeOfDay || !date) {
      return filtered.concat({
        provider,
        times,
        lastEndedVisitDateTime,
        date: availability.timeSlotCollection[0].date,
      });
    }

    const { startTime, endTime } = getStartAndEndTimes(timeOfDay, date, hour);

    return filtered.concat({
      date: availability.timeSlotCollection[0].date,
      lastEndedVisitDateTime,
      provider,
      times: times.filter((time) => {
        const timeSlotTime = getTimeSlotTime(time, date);
        return timeSlotTime.isBetween(startTime, endTime, null, '[)');
      }),
    });
  }, []);
}
export function getSoonestProviderId(availabilities: SoonestProviderIdProps[]) {
  if (!availabilities.length) return '';

  let providerId = availabilities[0]?.provider.id;
  let soonestTime = availabilities[0]?.times[0];
  if (!soonestTime) return '';
  let soonestTimeSlot = getTimeSlotTime(soonestTime, availabilities[0].date);
  for (let i = 1; i < 3; i++) {
    if (availabilities[i]) {
      const time = availabilities[i].times[0];
      if (time) {
        const timeSlotTime = getTimeSlotTime(time, availabilities[i].date);
        if (timeSlotTime.isBefore(soonestTimeSlot)) {
          providerId = availabilities[i].provider.id;
          soonestTime = availabilities[i]?.times[0];
          soonestTimeSlot = getTimeSlotTime(
            soonestTime,
            availabilities[i].date,
          );
        }
      }
    }
  }
  return providerId;
}
